import React from 'react';

const Modals = () => {
    return (<></>);
}
 
export default Modals;